import { RadioButton } from '../RadioButton';
import { Group } from './RadioGroup.styles';
import type { RadioGroupProps } from './RadioGroup.types';

export function RadioGroup({
  name,
  options,
  value,
  onChange,
  direction = 'row',
  hasError,
}: RadioGroupProps) {
  return (
    <Group
      role="radiogroup"
      $direction={direction}
      aria-invalid={hasError || undefined}
      tabIndex={hasError ? -1 : undefined}
    >
      {options.map((option) => (
        <RadioButton
          key={option.value}
          name={name}
          value={option.value}
          label={option.label}
          checked={value === option.value}
          onChange={onChange}
          disabled={option.disabled}
        />
      ))}
    </Group>
  );
}
